import React, { useState } from "react";
import EcoSystem from "assets/desktop-research/images/ecosystem-bg.png";
import EcoSystemImage from "assets/desktop-research/images/ecosystem-image.png";
import AccessReportModal from "./AccessReportModal";
import AnchorRightIcon from "assets/breakfast-event/svgs/anchor-right.svg";
import { useTranslation } from "react-i18next";

const EcoSystemSection = () => {
  const { t } = useTranslation("event");

  const [open, setOpen] = useState(false);

  const handleRedirect = () => {
    window.open(
      "https://drive.google.com/file/d/1gJcShzSSU6L-Ohzty-Lcxp_PEborDImq/view?usp=sharing",
      "_blank",
    );
  };
  return (
    <div className="flex justify-center items-center">
      <div
        className="!w-[1440px] lg:h-[520px] bg-cover bg-center scroll-mt-[90px] flex justify-center items-center flex-col md:flex-row gap-3 text-white"
        style={{ backgroundImage: `url(${EcoSystem})` }}
      >
        <div className="w-[92%] flex justify-center items-center">
          <div className="flex justify-between items-start flex-col lg:flex-row gap-20">
            <div className="text-[#334155] lg:w-[50%] space-y-5 xl:space-y-7 mt-10">
              <h2 className="text-[36px] font-euclidSemibold text-[#334155] md:w-[90%] xl:w-[75%]">
                {/* {t("desktopResearch.ecosystem.title")} */}
              </h2>
              <p className="text-[15px] font-euclidRegular">
                {t("desktopResearch.ecosystem.desc1")}{" "}
              </p>
              <p className="text-[15px] font-euclidRegular">
                {t("desktopResearch.ecosystem.desc2")}
              </p>
              <div className="flex items-center" onClick={handleRedirect}>
                <button className="bg-[#202D66] font-euclid text-white text-base xl:text-base font-euclidSemibold h-[48px] px-6 md:px-5 rounded-l-[16px] rounded-r-none">
                  {t("desktopResearch.cta2")}
                </button>
                <button className="bg-[#AFF7CD] text-white text-base font-euclidSemibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                  <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                </button>
              </div>
            </div>
            <div className="lg:w-[50%] !flex justify-center items-center lg:block">
              <img
                src={EcoSystemImage}
                alt="EcoSystemImage"
                className="w-full xl:h-[500px] md:h-[520px]"
              />
            </div>
          </div>
        </div>
      </div>
      <AccessReportModal isOpen={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export default EcoSystemSection;
